<template>
  <layout-main-inner :title="$route.meta.name">
    <div
      v-if="permission.LVL2 && memberFlag === 0"
      slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增企业
      </el-button>
      <el-dropdown>
        <el-button
          type="info"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtmp">
            下载模板
          </el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">
            批量上传
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          fixed="left"
          label="企业名称"
          min-width="180"
          prop="vendorName"> </el-table-column>
        <el-table-column
          label="企业信用代码"
          min-width="140"
          prop="unifiedCreditCode"> </el-table-column>
        <el-table-column
          label="营业执照"
          min-width="100"
          prop="businessLicenceFile">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.businessLicenceFile"
              fit="contain"
              style="width: 60px; height: 60px"
              :src="row.businessLicenceFile"
              :preview-src-list="[row.businessLicenceFile]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="企业类型"
          min-width="80"
          prop="vendorAddress">
          <template slot-scope="{ row }">
            {{ row.scmOpenFlag === 1 ? '供应链' : '非供应链' }}
          </template>
        </el-table-column>
        <el-table-column
          label="企业地址"
          min-width="220"
          prop="vendorAddress">
          <template slot-scope="{ row }">
            {{ row.provinceName }}-{{ row.cityName }}-{{ row.areaName }}-{{ row.vendorAddress }}
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          prop="vendorPerson"
          min-width="90"></el-table-column>
        <el-table-column
          label="手机号"
          prop="vendorPhone"
          min-width="100"></el-table-column>
        <el-table-column
          label="邀请人"
          prop="inviterName"
          min-width="100"></el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="所属机构"
          prop="sgsName"
          min-width="120"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="permission.LVL2 ? 165 : 80">
          <template slot-scope="{ row }">
            <!-- <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button> -->
            <el-button
              type="text"
              @click="navigateTo(row)">  查看详情 </el-button>
            <template v-if="permission.LVL2">
              <el-button
                type="text"
                @click="updateitem(row)"> 编辑 </el-button>
              <el-dropdown>
                <el-button
                  type="text"
                  style="margin-left: 10px;">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
                  <el-dropdown-item @click.native="setInviter(row)">设置邀请人</el-dropdown-item>
                  <el-dropdown-item @click.native="uploadWord(row)">导入/覆盖调研表</el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.surveyFormFile"
                    @click.native="downloaditem(row)">下载调研表</el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.scmOpenFlag === 0"
                    @click.native="createitem(row)">
                    开通供应链
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.vendorBindWxapp === 0"
                    @click.native="addStaff(row)">设置管理员</el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.memberFlag === 0"
                    @click.native="setMemberFlag(row)">设为合作企业</el-dropdown-item>
                  <template v-if="row.memberFlag === 1">
                    <el-dropdown-item @click.native="setMemberFlag(row)">设为潜在客户</el-dropdown-item>
                    <el-dropdown-item @click.native="updateExtraInfo(row)">扩展信息维护</el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">  </el-pagination>
    </layout-card-wrap>
    <edit-vendor-modal
      ref="edit"
      :callback="getlist" />
    <edit-staff-modal
      ref="staff"
      :callback="getlist" />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest">
      <i ref="upload"></i>
    </el-upload>
    <upload-new
      ref="uploadNew"
      :callback="uploadWordCallback" />
    <el-link
      ref="link"
      type="primary"
      style="display:none;"
      :underline="false"
      :href="surveyFormFile"
      target="_blank"
      rel="noopener noreferrer">{{ surveyFormFile }}</el-link>

    <edit-vendor-extra-modal
      ref="extra"
      @fetch="getlist" />
    <vendor-inviter-select-modal
      ref="invite"
      @fetch="getlist" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import UploadNew from '../../../components/upload-new.vue'
import EditStaffModal from '../edit-staff-modal.vue'
import EditVendorModal from '../edit-vendor-modal.vue'
import EditVendorExtraModal from './edit-vendor-extra-modal.vue'
import VendorInviterSelectModal from './vendor-inviter-select-modal.vue'
export default {
  name: 'VendorList',
  components: { EditVendorModal, UploadNew, EditStaffModal, EditVendorExtraModal, VendorInviterSelectModal },
  props: {
    memberFlag: { type: Number }
  },
  data() {
    return {
      loading: true,
      totalApplys: 0,
      list: [],
      totalNum: 0,
      deleteable: process.env.NODE_ENV,
      surveyFormFile: '',
      download: '',
      config: { pageNum: 1, pageSize: 10, vendorName: '', appraisalOpenFlag: 0 }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
    // this.getapplyvendors()
  },
  methods: {
    setInviter(row) {
      const { vendorId, vendorName } = row
      this.$refs.invite.fetch({ vendorId, vendorName })
    },
    navigateTo(row) {
      this.$router.push({ path: '/member-vendor-detail', query: { vendorId: row.vendorId }})
    },
    addStaff(row) {
      this.$refs.staff.update({ orgId: row.vendorId, vendorName: row.vendorName })
    },
    downloaditem(row) {
      this.surveyFormFile = row.surveyFormFile.split('?')[0]
      this.download = row.surveyFormFile.split('originalfilename')[1].slice(1)
      this.$nextTick(() => {
        this.$refs.link.$el.click()
      })
    },
    uploadWord(row) {
      this.$refs.uploadNew.upload({ vendorId: row.vendorId })
    },
    uploadWordCallback(options, surveyFormFile) {
      console.log(options, surveyFormFile)
      this.loading = true
      this.$store.dispatch(`account/updatevendor`, {
        payload: { ...options, surveyFormFile },
        success: () => {
          this.$message.success('更新成功')
          this.loading = false
          this.getlist()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    downloadtmp() {
      this.loading = true
      this.$store.dispatch('account/getvendoruploadtemplate', {
        payload: {},
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.loading = true
      this.$store.dispatch('account/uploadvendor', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    uploadtmp() {
      this.$refs.upload.click()
    },
    additem() {
      this.$refs.edit.update()
    },
    updateitem(row) {
      // this.$router.push(`/editvendor?vendorId=${row.vendorId}`)
      const { vendorId, vendorName, adminAccount, unifiedCreditCode, businessLicenceFile, vendorAddress, vendorPerson, vendorPhone, provinceCode, cityCode, areaCode } = row
      const LicenceFile = businessLicenceFile ? [{ url: businessLicenceFile }] : []
      const area = [provinceCode, cityCode, areaCode]
      this.$refs.edit.update({ vendorId, vendorName, adminAccount, unifiedCreditCode, businessLicenceFile: LicenceFile, area, vendorAddress, vendorPerson, vendorPhone })
    },
    updateExtraInfo(row) {
      const { vendorId, vendorName, coverImage, descImages, vendorDesc, vendorShortname, labels, companyBusinessCategorys } = row
      this.$refs.extra.init({
        vendorDesc, vendorShortname, vendorId, vendorName, labels: labels || [], companyBusinessCategorys: companyBusinessCategorys || [],
        coverImage: this.$splitImage(coverImage),
        descImages: this.$splitImage(descImages)
      })
    },
    createitem(row) {
      if (row.needImproveInformation === 1) {
        this.$message.error('请先完善企业信息')
        return
      }
      this.$prompt('请输入企业账号', '开通供应链', { confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /[0-9a-zA-Z]{4,}/, inputErrorMessage: '账号至少4位，只能输入0-9，a-z，A-Z' })
        .then(({ value }) => {
          this.loading = true
          this.$store.dispatch('account/openscm', {
            payload: { vendorId: row.vendorId, open: 1, scmAdminAccount: value },
            success: () => {
              this.$message.success('开通成功')
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该企业?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/deletevendor', {
            payload: { vendorId: row.vendorId },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    setMemberFlag(row) {
      const title = row.memberFlag === 1 ? '潜在客户' : '合作企业'
      this.$confirm(`您确定该企业设置为${title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/updatevendor', {
            payload: { vendorId: row.vendorId, memberFlag: +(!row.memberFlag) },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
              this.$message.success('设置成功')
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getvendors', {
        payload: { memberFlag: this.memberFlag, ...this.config },
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
